import { createFileRoute } from '@tanstack/react-router';
import { AiSkillsPage } from '@/pages/ai-assistant';

export const Route = createFileRoute('/_protected/ai-chat/')({
  component: AiSkillsPage,
});
